import httpClient from "../../api/httpClient";
import { createWrappedAsyncThunk } from "../createWrappedAsyncThunk";

export const loginThunk = createWrappedAsyncThunk(
  "auth/login",
  async (credentials) => {
    const {
      data: { user, token },
    } = await httpClient.publicPost(`sign-in`, credentials);

    httpClient.setAccessToken(token);

    return user;
  }
);
